import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["icon"]
  static values = {
    url: String,
    showClient: String,
    showStatement: String
  }

  async toggle(event) {
    event.preventDefault()

    const icon = this.iconTarget.querySelector("i")
    const isCurrentlyVerified = icon.classList.contains("fa-check-circle")
    const newValue = !isCurrentlyVerified

    // Optimistically update UI
    this.updateIcon(icon, newValue)

    try {
      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content
      const response = await fetch(this.urlValue, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          "Accept": "text/vnd.turbo-stream.html"
        },
        body: JSON.stringify({
          line_item: { balance_validated: newValue },
          show_client: this.showClientValue,
          show_statement: this.showStatementValue
        })
      })

      if (!response.ok) {
        // Revert on failure
        this.updateIcon(icon, isCurrentlyVerified)
      }
    } catch (error) {
      // Revert on error
      this.updateIcon(icon, isCurrentlyVerified)
    }
  }

  updateIcon(icon, verified) {
    if (verified) {
      icon.classList.remove("fa-times-circle", "text-gray-300", "hover:text-gray-400")
      icon.classList.add("fa-check-circle", "text-green-500")
      this.iconTarget.title = "Verified"
    } else {
      icon.classList.remove("fa-check-circle", "text-green-500")
      icon.classList.add("fa-times-circle", "text-gray-300", "hover:text-gray-400")
      this.iconTarget.title = "Not verified"
    }
  }
}
